<template>
  <div class="page-wrap">
    <div class="search-area">
      <h1 class="title">搜索结果："{{keyword}}"</h1>
      <div>
        <input type="text" class="search-input">
      </div>
    </div>
    <div class="goods-list">
      <el-row :gutter="20">
        <el-col :span="8" v-for="(goods, index) in goodsList" v-bind:key="index">
          <div class="goods-item" @mouseleave="goods.image=1" @mouseenter="goods.image=0" @click="goto('/product/'+goods.id)">
            <img class="goods-image" :src="goods.image==1?goods.image_1:goods.image_2">
            <div class="goods-name">{{goods.name}}</div>
            <div class="goods-ename">{{goods.name_e}}</div>
            <div class="goods-price">￥{{goods.price}}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="g-pagination-wrap">
      <el-pagination background layout="total, prev, pager, next" :total=total :current-page.sync="page" :page-size="9" @current-change="handlePageChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import { config } from '@/self/config.js'
export default {
  data () {
    return {
      keyword: '',
      goodsList: [],
      total: 0,
      page: 1
    }
  },
  watch: {
    $route (to, from) {
      this.page = 1
      this.keyword = this.$route.params.keyword
      if (this.keyword) {
        this.getGoodsByKeyword(1)
      }
    }
  },
  methods: {
    handlePageChange (page) {
      this.getGoodsByKeyword(page)
    },
    getGoodsByKeyword (page) {
      const that = this
      that.axios.get('goods', { params: { page, keyword: that.keyword, pageSize: 9 } }).then(function (resp) {
        const list = []
        that.total = resp.data.total
        for (let i = 0; i < resp.data.list.length; i++) {
          const goods = resp.data.list[i]
          goods.image_1 = config.imageDisplayBaseUrl + goods.image_1
          goods.image_2 = config.imageDisplayBaseUrl + goods.image_2
          goods.image = 1
          list.push(goods)
        }
        that.goodsList = list
      })
    },
    goto (url) {
      this.$router.push(url)
    },
    setKeyword () {
      if (this.$route.params.keyword !== '') {
        this.keyword = this.$route.params.keyword
        this.getGoodsByKeyword(1)
      }
    }
  },
  mounted () {
    this.setKeyword()
  }
}
</script>

<style scoped>
.page-wrap{
  margin: 0 auto;
  max-width: 1200px;
  box-sizing: border-box;
  padding: 100px 0 50px;
}
.search-area{
  display: flex;
  justify-content: space-between;
}
.search-input{
  display: none;
}
.title{
  font-style: normal;
  font-size: 22px;
  font-weight: 400;
  line-height: 1.5;
  color: #25282a;
  margin-bottom: 15px;
}
.goods-list{
  padding: 100px 0 50px;
}
.goods-item{
  box-sizing: border-box;
  background-color: white;
  text-align: center;
  color: #25282a;
  font-weight: 400;
  font-size: 16px;
  font-style: normal;
  margin-bottom: 20px;
  border: 1px solid #fff;
  padding: 20px 5px;
  cursor: pointer;
}
.goods-item:hover{
  border: 1px solid #d2d2d4;
}
.goods-image{
  width: 60%;
}
.goods-name{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 30px;
}
.goods-ename{
  height: 40px;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.goods-price{
  font-weight: 700;
  padding: 10px;
}
</style>
